// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const CustomTermsOfServiceSVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '193'}
        height={props.height ? props.height.toString() : '111'}
        viewBox='0 0 193 111'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <rect
            x='193'
            y='27'
            width='66'
            height='193'
            rx='2'
            transform='rotate(90 193 27)'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <path
            d='M10 45L10 53.7097L166.84 53.7097L166.84 63L182 63'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M19.0974 76.51L19.0974 60.445L34.8649 60.445'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <ellipse
            cx='1.5'
            cy='1.5'
            rx='1.5'
            ry='1.5'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 8.5 45)'
            fill='var(--center-channel-color)'
            fillOpacity='0.56'
        />
        <ellipse
            cx='1.4875'
            cy='1.4875'
            rx='1.4875'
            ry='1.4875'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 17.61 79.485)'
            fill='var(--center-channel-color)'
            fillOpacity='0.56'
        />
        <ellipse
            cx='1.4875'
            cy='1.4875'
            rx='1.4875'
            ry='1.4875'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 181.09 64.61)'
            fill='var(--center-channel-color)'
            fillOpacity='0.56'
        />
        <rect
            x='35'
            y='16'
            width='132.5'
            height='87'
            rx='4'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='4'
        />
        <path
            d='M37.2992 19.7992C37.2992 18.9708 37.9708 18.2992 38.7992 18.2992H163.701C164.529 18.2992 165.201 18.9708 165.201 19.7992V27.9724H37.2992V19.7992Z'
            fill='var(--button-bg)'
            fillOpacity='0.16'
        />
        <rect
            x='80.2914'
            y='82.7874'
            width='41.9173'
            height='8.59843'
            rx='2'
            fill='var(--button-bg)'
        />
        <path
            d='M71.1178 37H84.5296'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M71.1178 41H95.706'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M71.1178 45H81.1766'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M70.0001 55H106.882'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M70.0001 66.1646H113.588'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M70 71.5525H127'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M70.0001 60.7764H91.2354'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M96.8237 60.7764H112.105'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M116.69 60.7764H124.331'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <circle
            cx='41.5'
            cy='22.5'
            r='1.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='49.5'
            cy='22.5'
            r='1.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='57.5'
            cy='22.5'
            r='1.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M116 110L125 110'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <path
            d='M128 110L132 110'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <path
            d='M135 110L165 110'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <path
            d='M113 110L101 110L101 90'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M154.5 60C170.24 60 183 47.2401 183 31.5C183 15.7599 170.24 3 154.5 3C138.76 3 126 15.7599 126 31.5C126 47.2401 138.76 60 154.5 60Z'
            fill='var(--neutral-1200'
            fillOpacity='0.16'
        />
        <path
            d='M154.5 57C170.24 57 183 44.2401 183 28.5C183 12.7599 170.24 0 154.5 0C138.76 0 126 12.7599 126 28.5C126 44.2401 138.76 57 154.5 57Z'
            fill='var(--indigo-400)'
        />
        <path
            d='M142 29.3101L151.28 38L169 19'
            stroke='var(--neutral-0)'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export default CustomTermsOfServiceSVG;
